import { render, staticRenderFns } from "./TitleReasons.vue?vue&type=template&id=1be3ef8a&"
import script from "./TitleReasons.vue?vue&type=script&lang=js&"
export * from "./TitleReasons.vue?vue&type=script&lang=js&"
import style0 from "./TitleReasons.vue?vue&type=style&index=0&id=1be3ef8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports